export default __webpack_public_path__ + "static/1-1f34ffb66b48354e17a9e6ffb957d1e6.jpeg";